import { useCallback } from 'react'

import {
  TRANSACTIONS_FILTERS_STORAGE_KEY,
  TransactionsFilterFormFields,
} from '../components/transactions-filters/types'

/**
 * Hook to manage transactions filters state in sessionStorage and clean up.
 */
const usePersistedTransactionFilters = () => {
  /**
   * Persists transactions filters in sessionStorage.
   */
  const setTransactionstFilterState = useCallback((filters: TransactionsFilterFormFields) => {
    sessionStorage.setItem(TRANSACTIONS_FILTERS_STORAGE_KEY, JSON.stringify(filters))
  }, [])

  /**
   * Resets transactions filters from sessionStorage.
   */
  const resetTransactionstFilterState = useCallback(() => {
    sessionStorage.removeItem(TRANSACTIONS_FILTERS_STORAGE_KEY)
  }, [])

  return {
    setTransactionstFilterState,
    resetTransactionstFilterState,
  }
}

export default usePersistedTransactionFilters
